import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeText } from '../traitTypes/TraitTypeText';
export class TraitRegistryPrimitives extends TraitRegistryCategory {
    label = 'Primitives';
    constructor(parent) {
        super(parent);
        super.init();
    }
    number1To10 = () => new TraitTypeSelectWithPreview({
        /*  label: 'Zahl 1 bis 10',
        select: [[1], [2], [3], [4], [5], [6], [7], [8], [9], [10]], */
        default: 1,
    });
    scaleFactor = () => new TraitTypeNumericWithSlider({
        max: 10,
        min: 0.1,
        step: 0.01,
        default: 1,
    });
    stringValue = () => new TraitTypeText();
    comparator = () => new TraitTypeSelect({
        /* label: 'Vergleicher',
        select: [['>'], ['<'], ['<='], ['>='], ['==='], ['!==']], */
        default: '===',
    });
    leftValue = () => new TraitTypeText({
        label: 'Linker Wert',
        default: '0',
    });
    rightValue = () => new TraitTypeText({
        label: 'Rechter Wert',
        default: '0',
    });
    switchName = () => new TraitTypeSelect({
        label: 'Switch',
        default: '',
        select: [['signalName']], // this.registryRoof.c_signals.allLeafs.map(leaf => [leaf.key, `${leaf.label} ${leaf.key}`]) as any,
    });
    switchValue = () => new TraitTypeText({
        label: 'Switch Wert',
        default: '',
    });
    signal = () => new TraitTypeSelect({
        select: [['signalName']],
        aspectsTemplate: { core: ['signalValue'] },
        default: '',
    });
    signalValue = () => new TraitTypeText({
        label: 'Signal Wert',
        default: '',
    });
    timespanInMilliseconds = () => new TraitTypeNumericWithSlider({
        label: 'Zeitspanne Millisekunden',
        default: 0,
        min: 0,
        step: 1000,
        max: 30000,
    });
    markName = () => new TraitTypeText({
        default: '',
    });
    /*
    readonly rememberStore = () =>
      new TraitTypeSelect({
        label: 'Remember Store',
        select: [['topic']]
      });
  */
    scope = () => new TraitTypeSelect({
        label: 'Scope',
        default: 'global',
        select: [['global'], ['local']],
    });
}
